import _toConsumableArray from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { getRequiredValues, getAllValues, titleCase, getAuthenticatorFromRemediation } from '../util.js';
import { formatAuthenticator, compareAuthenticators } from '../../authenticator/util.js';
var Remediator = /*#__PURE__*/function () {
  function Remediator(remediation) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Remediator);
    this.values = Object.assign({}, values);
    this.options = Object.assign({}, options);
    this.formatAuthenticators();
    this.remediation = remediation;
  }
  return _createClass(Remediator, [{
    key: "formatAuthenticators",
    value: function formatAuthenticators() {
      this.values.authenticators = this.values.authenticators || [];
      this.values.authenticators = this.values.authenticators.map(function (authenticator) {
        return formatAuthenticator(authenticator);
      });
      if (this.values.authenticator) {
        var authenticator = formatAuthenticator(this.values.authenticator);
        var hasAuthenticatorInList = this.values.authenticators.some(function (existing) {
          return compareAuthenticators(authenticator, existing);
        });
        if (!hasAuthenticatorInList) {
          this.values.authenticators.push(authenticator);
        }
      }
      this.values.authenticatorsData = this.values.authenticators.reduce(function (acc, authenticator) {
        if (typeof authenticator === 'object' && Object.keys(authenticator).length > 1) {
          acc.push(authenticator);
        }
        return acc;
      }, this.values.authenticatorsData || []);
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.remediation.name;
    }
  }, {
    key: "canRemediate",
    value: function canRemediate(context) {
      var _this = this;
      var required = getRequiredValues(this.remediation);
      var needed = required.find(function (key) {
        return !_this.hasData(key);
      });
      if (needed) {
        return false;
      }
      return true;
    }
  }, {
    key: "getData",
    value: function getData(key) {
      var _this2 = this;
      if (!key) {
        var allValues = getAllValues(this.remediation);
        var res = allValues.reduce(function (data, key) {
          data[key] = _this2.getData(key);
          return data;
        }, {});
        return res;
      }
      if (typeof this["map".concat(titleCase(key))] === 'function') {
        var val = this["map".concat(titleCase(key))](this.remediation.value.find(function (_ref) {
          var name = _ref.name;
          return name === key;
        }));
        if (val) {
          return val;
        }
      }
      if (this.map && this.map[key]) {
        var entry = this.map[key];
        for (var i = 0; i < entry.length; i++) {
          var _val = this.values[entry[i]];
          if (_val) {
            return _val;
          }
        }
      }
      return this.values[key];
    }
  }, {
    key: "hasData",
    value: function hasData(key) {
      return !!this.getData(key);
    }
  }, {
    key: "getNextStep",
    value: function getNextStep(_authClient, _context) {
      var name = this.getName();
      var inputs = this.getInputs();
      var authenticator = this.getAuthenticator();
      var type = authenticator === null || authenticator === void 0 ? void 0 : authenticator.type;
      return Object.assign(Object.assign({
        name: name,
        inputs: inputs
      }, type && {
        type: type
      }), authenticator && {
        authenticator: authenticator
      });
    }
  }, {
    key: "getInputs",
    value: function getInputs() {
      var _this3 = this;
      var inputs = [];
      var inputsFromRemediation = this.remediation.value || [];
      inputsFromRemediation.forEach(function (inputFromRemediation) {
        var input;
        var name = inputFromRemediation.name,
          type = inputFromRemediation.type,
          visible = inputFromRemediation.visible,
          messages = inputFromRemediation.messages;
        if (visible === false) {
          return;
        }
        if (typeof _this3["getInput".concat(titleCase(name))] === 'function') {
          input = _this3["getInput".concat(titleCase(name))](inputFromRemediation);
        } else if (type !== 'object') {
          var alias;
          var aliases = (_this3.map ? _this3.map[name] : null) || [];
          if (aliases.length === 1) {
            alias = aliases[0];
          } else {
            alias = aliases.find(function (name) {
              return Object.keys(_this3.values).includes(name);
            });
          }
          if (alias) {
            input = Object.assign(Object.assign({}, inputFromRemediation), {
              name: alias
            });
          }
        }
        if (!input) {
          input = inputFromRemediation;
        }
        if (Array.isArray(input)) {
          input.forEach(function (i) {
            return inputs.push(i);
          });
        } else {
          if (messages) {
            input.messages = messages;
          }
          inputs.push(input);
        }
      });
      return inputs;
    }
  }, {
    key: "getValuesAfterProceed",
    value: function getValuesAfterProceed() {
      var inputsFromRemediation = this.remediation.value || [];
      var inputsFromRemediator = this.getInputs();
      var inputs = [].concat(_toConsumableArray(inputsFromRemediation), _toConsumableArray(inputsFromRemediator));
      var _iterator = _createForOfIteratorHelper(inputs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var input = _step.value;
          delete this.values[input.name];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return this.values;
    }
  }, {
    key: "getAuthenticator",
    value: function getAuthenticator() {
      var _a, _b;
      var relatesTo = (_a = this.remediation.relatesTo) === null || _a === void 0 ? void 0 : _a.value;
      if (!relatesTo) {
        return;
      }
      var authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
      if (!authenticatorFromRemediation) {
        return relatesTo;
      }
      var id = authenticatorFromRemediation.form.value.find(function (_ref2) {
        var name = _ref2.name;
        return name === 'id';
      }).value;
      var enrollmentId = (_b = authenticatorFromRemediation.form.value.find(function (_ref3) {
        var name = _ref3.name;
        return name === 'enrollmentId';
      })) === null || _b === void 0 ? void 0 : _b.value;
      return Object.assign(Object.assign({}, relatesTo), {
        id: id,
        enrollmentId: enrollmentId
      });
    }
  }], [{
    key: "getMessages",
    value: function getMessages(remediation) {
      var _a, _b;
      if (!remediation.value) {
        return;
      }
      return (_b = (_a = remediation.value[0]) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.value.reduce(function (messages, field) {
        if (field.messages) {
          messages = [].concat(_toConsumableArray(messages), _toConsumableArray(field.messages.value));
        }
        return messages;
      }, []);
    }
  }]);
}();
export { Remediator };